import { useEffect } from "react";

const useOutsideClick = (ref, func) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        func();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [func, ref]);
};

export default useOutsideClick;

/**
 * @exports useOutsideClick
 * @function useOutsideClick
 * @kind Hook
 *
 * @description
 * Execute function when catch click outside wrapped component
 *
 * @param {Node} ref - references to wrapper component
 * @returns {Function} func - callback when click happened outside wrapper component
 *
 */
